import { Layout } from 'antd';
import type { PropsWithChildren } from 'react';
import React from 'react';

interface Props {}

const PageContentWrapper: React.FC<PropsWithChildren<Props>> = (props): React.ReactElement => {
  const { children } = props;

  return <Layout className="PageContentWrapper">{children}</Layout>;
};

export default PageContentWrapper;
